import type { ReactNode } from "react";

export interface Column<Row> {
  key: string;
  header: ReactNode;
  cell: (row: Row) => ReactNode;
  /** Right-aligned, tabular numerals (money, counts). */
  numeric?: boolean;
}

interface TableProps<Row> {
  caption: ReactNode;
  /** Hide the caption visually but keep it for screen readers. */
  captionHidden?: boolean;
  columns: Array<Column<Row>>;
  rows: Row[];
  rowKey: (row: Row) => string;
  empty?: ReactNode;
}

export function Table<Row>({ caption, captionHidden, columns, rows, rowKey, empty }: TableProps<Row>) {
  if (rows.length === 0 && empty) return <>{empty}</>;
  return (
    <div className="table-wrap">
      <table className="table">
        <caption className={captionHidden ? "visually-hidden" : undefined}>{caption}</caption>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} scope="col" className={c.numeric ? "num" : undefined}>
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={rowKey(r)}>
              {columns.map((c) => (
                <td key={c.key} className={c.numeric ? "num" : undefined}>
                  {c.cell(r)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
